import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";

export default function ConnectionSetup({ entry, onSaved }) {
  const [setup, setSetup] = useState(null), [error, setError] = useState("");
  const [account, setAccount] = useState(""), [busy, setBusy] = useState(false);
  useEffect(() => {
    let active = true;
    setSetup(null); setError(""); setAccount("");
    api.get("/connections/" + entry.id + "/setup").then(({data}) => {
      if (active) { setSetup(data); setAccount(data.configuration?.business_account_id || ""); }
    }).catch(e => { if (active) setError(errMsg(e)); });
    return () => { active = false; };
  }, [entry.id]);
  const save = async () => {
    setBusy(true); setError("");
    try {
      await api.put("/connections/" + entry.id + "/configuration", { business_account_id: account });
      setError("Cuenta guardada. Todavía falta autorizar o probar su acceso.");
      await onSaved();
      const fresh = await api.get("/connections/" + entry.id + "/setup");
      setSetup(fresh.data);
    } catch(e) { setError(errMsg(e)); }
    finally { setBusy(false); }
  };
  return <section className="space-y-3 border border-cyan-800 rounded p-3" aria-label="Preparar conexión">
    <h4 className="text-cyan-200">Preparar conexión oficial</h4>
    {!setup && !error && <p role="status">Comprobando requisitos…</p>}
    {setup && <>
      <ul className="space-y-2 text-sm">{setup.checks.map(c => <li key={c.id}><span aria-hidden="true">{c.ready ? "✓" : "○"} </span>{c.label}: {c.ready ? "Listo" : "Pendiente"}</li>)}</ul>
      <ol className="list-decimal pl-5 space-y-2 text-sm">{setup.requirements.map(r => <li key={r}>{r}</li>)}</ol>
      <a href={setup.developer_url} target="_blank" rel="noreferrer" className="inline-block min-h-[44px] py-3 underline text-cyan-300">Abrir portal oficial de desarrolladores</a>
      {setup.callback_url && <p className="text-xs break-all">URL de retorno que debe registrarse: {setup.callback_url}</p>}
      <p className="text-xs text-slate-400">Los secretos de la app se configuran en el servidor. Este panel no muestra credenciales ni las guarda en el navegador.</p>
      {entry.id === "whatsapp-business" && <div className="space-y-2">
        <label className="block text-sm" htmlFor="waba-account">ID de cuenta WhatsApp Business (WABA)</label>
        <input id="waba-account" inputMode="numeric" maxLength={30} value={account} onChange={e => setAccount(e.target.value.replace(/[^0-9]/g,""))} className="bg-slate-900 border border-cyan-700 rounded p-3 w-full" autoComplete="off" aria-describedby="waba-note"/>
        <p id="waba-note" className="text-xs text-slate-400">Es el ID de la cuenta empresarial de Meta, no tu número. Guardarlo no migra ni registra tu teléfono.</p>
        <button type="button" disabled={busy || !/^[0-9]{5,30}$/.test(account)} onClick={save} className="min-h-[44px] border border-cyan-500/40 rounded px-3 disabled:opacity-40">Guardar cuenta empresarial</button>
      </div>}
      <ul className="text-sm text-amber-200 space-y-2">{setup.limitations.map(l => <li key={l}>{l}</li>)}</ul>
      <p className="text-xs">{setup.ready_to_authorize ? "Configuración preparada para solicitar tu autorización." : "Todavía hay requisitos pendientes. Una sesión de navegador abierta no autoriza a JARVIS."}</p>
    </>}
    {error && <p role="status" className="text-sm text-amber-200">{error}</p>}
  </section>;
}
